<template>
  <div>
    <b-table
        head-row-variant="info"
        table-variant="white"
        :items="basketList"
        :fields="basketListHeaders"
        hover
        responsive
        :per-page="perPage"
        :busy="basketListLoading"
        style="font-size:12px"
        show-empty
    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : noBasketMessage }}
        </h6>
      </template>
      <template #cell(process)="data">
        <div class="text-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="amber darken-2"
                  @click="openNewBasketDialog(data.item.id)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Düzenle</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="danger darken-2"
                  @click="_basketDelete(data.item.id)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span>Sil</span>
          </v-tooltip>
        </div>
      </template>
      <template #cell(startDate)="data">
        {{ formattedDate(data.item.startDate, "DD MMMM YYYY") }}
      </template>
      <template #cell(finishDate)="data">
        {{ formattedDate(data.item.finishDate, "DD MMMM YYYY") }}
      </template>
      <template #cell(isActive)="data">
        <v-chip small label outlined :color="data.item.isActive === true ? 'success darken-1' : 'secondary darken-1'">
          {{ data.item.isActive === true ? 'Aktif' : 'Devre Dışı' }}
        </v-chip>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
          ></b-spinner>
        </div>
      </template>
    </b-table>
    <NewBasketDialog
        :showDialog="showNewBasketDialog"
        :processType="'edit'"
        :basketId="basketIdValue"
        @dialogChange="(e) => (showNewBasketDialog = e)"
    ></NewBasketDialog>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import NewBasketDialog from "@/components/campaign/basket/dialogs/NewBasketDialog";
import {formattedDate} from "@/momentHelper";

export default {
  components: {
    NewBasketDialog
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  computed: {
    ...mapState("basket", ["basketList", "basketListHeaders", "basketListLoading", "noBasketMessage"]),
  },
  data() {
    return {
      showNewBasketDialog: false,
      basketIdValue: null,
    };
  },
  methods: {
    formattedDate,
    ...mapActions("basket", ["basketDelete"]),
    openNewBasketDialog(id) {
      this.basketIdValue = id;
      this.showNewBasketDialog = true;
    },
    async _parentBasketList() {
      this.$parent._fetchBasketList();
    },
    async _basketDelete(id) {
      await this.basketDelete({
        params: {},
        body: {},
        urlSegments: [id]
      }).then(() => {
        //this._parentBasketList();
      });

    },
  },
  watch: {},
};
</script>
